import * as core from "@twiage/core";
import type { User } from "@twiage/core/types/User";
import { mainEventBus, promiseAction } from "@twiage/utils";

import { useTrackedPromise } from "../../composables/use-tracked-promise";
import type { Credentials } from "../../types/Credentials";

export const makeUserTrackedPromise = () =>
  useTrackedPromise<Credentials, User>({
    action: promiseAction.read,

    asyncFunction: core.login,

    onFulfilled: () => {
      // TODO Create event symbols for these
      mainEventBus.emit("Authentication.User.Login_after");
    },
  });
